import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'cp-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNotFoundComponent {}
